// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"styles-module__iconWrapper___3Pxd4"};